export const OFFER_URL = 'https://offer.emajin.golf/'
